import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useDeleteOrderMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { useNotifyMessages } from 'api/helpers/useNotifyMessages';

export const useDeleteOrder = () => {
  const [handle, { loading, error: apolloError }] = useDeleteOrderMutation();

  const notifyMessage = useNotifyMessages();

  const error = useError(apolloError);

  const deleteOrder = useCallback(
    async (orderId: string, versionNumber: number) => {
      const res = await handle({
        variables: {
          id: orderId,
          versionNumber,
        },
      });

      if (res.data?.deleteOrder?.messages) {
        notifyMessage(res.data.deleteOrder.messages);
      }

      return res.data?.deleteOrder?.data;
    },
    [handle, notifyMessage]
  );

  return {
    loading,
    error,
    deleteOrder,
  };
};
